module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_4.58fb55db.png";